import React, {useState, useEffect} from 'react';
import {TextOutlineWrapper} from "../TextOutlineWrapper/TextOutlineWrapper"

interface MyComponentProps {
  workGroupId: string
  handleChangeInfo?: any,
}

export const WorkGroup: React.FC<MyComponentProps> = (props) => {
  return (
    <div>
      <h1>{props.workGroupId}</h1>
          <div>
          <TextOutlineWrapper
          focusResourceid={props.workGroupId}
          resourceid={props.workGroupId}
          title={props.workGroupId}
          hidden={false}
          mtFocus={""}
          collectionLink={true}
          showAuthor={true}
          showParentLink={true}
          showFirstLevelChildren={true}
          handleChangeInfo={props.handleChangeInfo}/>
        </div>
    </div>

  );
}
